import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FlexLayoutModule } from "@ngbracket/ngx-layout";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { MatMenuModule } from "@angular/material/menu";

import { CommandsModule } from "@tylertech/commands-module";
import { CoreModule } from "@tylertech/core-module";
import { LgdCheckboxModule, LgdSelectModule } from "@tylertech/lgd-reactive-forms";
import { CommonComponentsModule } from "@tylertech/common-components-module";
import { CommonDialogsModule } from "@tylertech/common-dialogs-module";
import { MetadataModule } from "@tylertech/metadata-module";

import * as services from "./services";
import * as components from "./components";
import { AttachmentsModule } from "@tylertech/attachments-module";

const angularModules = [
    CommonModule,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
];

const angularMaterialModules = [
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatMenuModule,
];

const lgdModules = [
    CommandsModule,
    CoreModule,
    CommonComponentsModule,
    CommonDialogsModule,
    AttachmentsModule,
    MetadataModule,
    LgdCheckboxModule,
    LgdSelectModule
];

const exportedComponents = [
    components.NoteAndAttachmentComponent,
    services.MassUpdateDialogComponent,
    services.DocTypeDialogComponent
];

//  TODO - this module should be merged with CommonComponents after it is converted off AngularJs now that the Dependency structure between library/common-components and library/core has been inverted.
@NgModule({
    imports: [
        ...angularModules,
        ...angularMaterialModules,
        ...lgdModules
    ],
    declarations: exportedComponents,
    exports: exportedComponents,
    providers: [
        services.MassUpdateService,
        services.AdvancedComponentsDialogService
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AdvancedComponentsModule { }
